import styled from 'styled-components';
import * as Shared from '../components/shared.styles';

export const PageWrapper = Shared.PageWrapper;
export const Navbar = Shared.Navbar;
export const NavContent = Shared.NavContent;
export const Logo = Shared.Logo;
export const ThemeToggleButton = Shared.ThemeToggleButton;
export const LightModeIcon = Shared.LightModeIcon;
export const DarkModeIcon = Shared.DarkModeIcon;
export const HeroSection = Shared.HeroSection;
export const HeroContent = Shared.HeroContent;
export const HeroTitle = Shared.HeroTitle;
export const HeroSubtitle = Shared.HeroSubtitle;
export const CTAButton = Shared.CTAButton;
export const ContentSection = Shared.ContentSection;
export const ContactSection = Shared.ContactSection;
export const ContactGrid = Shared.ContactGrid;
export const ContactInfo = Shared.ContactInfo;
export const ContactTitle = Shared.ContactTitle;
export const ContactDescription = Shared.ContactDescription;
export const ContactDetails = Shared.ContactDetails;
export const ContactItem = Shared.ContactItem;
export const ContactLabel = Shared.ContactLabel;
export const ContactValue = Shared.ContactValue;
export const FormCard = Shared.FormCard;
export const FormGrid = Shared.FormGrid;
export const FormGroup = Shared.FormGroup;
export const FormLabel = Shared.FormLabel;
export const Required = Shared.Required;
export const FormInput = Shared.FormInput;
export const FormTextarea = Shared.FormTextarea;
export const FormActions = Shared.FormActions;
export const SubmitButton = Shared.SubmitButton;
export const AcknowledgementSection = Shared.AcknowledgementSection;
export const AcknowledgementText = Shared.AcknowledgementText;
export const AcknowledgementImage = Shared.AcknowledgementImage;
export const Footer = Shared.Footer;
export const FooterContent = Shared.FooterContent;
export const FooterText = Shared.FooterText;
export const FooterLink = Shared.FooterLink;
export const FooterLinks = Shared.FooterLinks;
export const SocialLinks = Shared.SocialLinks;
export const SocialIcon = Shared.SocialIcon;
export const FooterWrapper = Shared.FooterWrapper;
export const FooterLeftSection = Shared.FooterLeftSection;
export const AcknowledgementFooterText = Shared.AcknowledgementFooterText;
export const FooterCopyright = Shared.FooterCopyright;
export const FooterPolicies = Shared.FooterPolicies;
export const FooterCenterSection = Shared.FooterCenterSection;
export const FooterRightSection = Shared.FooterRightSection;
export const FlagsContainer = Shared.FlagsContainer;
export const FlagImage = Shared.FlagImage;
export const AppStoresContainer = Shared.AppStoresContainer;
export const SignInButton = Shared.SignInButton;
export const HeroLogo = Shared.HeroLogo;

export const Section = styled.div`
  margin-top: ${({ theme }) => theme.landingSpacing.xl};

  &:first-child {
    margin-top: 0;
  }
`;

export const SectionHeader = Shared.SectionHeader;
export const SectionText = Shared.SectionText;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  /* margin-bottom: 1.25rem; */
`;

export const LogoWrapper = styled.div`
  /* width: 110px;
  height: 110px;
  padding: 1rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.landing.background};
  box-shadow: 0px 0px 50px rgb(72, 176, 238);
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center; */
`;
